import * as yup from 'yup';

const ForgotPasswordFormValidation = yup.object().shape({
  name: yup.string().trim().email().required('Email is a required field'),
});
export default ForgotPasswordFormValidation;
